import get from 'lodash.get'
import Vue from 'vue'

import reportsConfig from '../reports/config.json'
const module = {
  state: {
    showRegDrivers: true,
    fullReportList: reportsConfig['fullReportList'],
    // exclude from full report list
    adminReportList: reportsConfig['adminReportList'],
    bustCacheSlugGroups: reportsConfig['bustCacheSlugGroups'],
    widgetMixins: reportsConfig['widgetMixins'],
    isFetchingLimits: false,
    reportsWithLimits: {},
  },
  getters: {
    reportFilter: (_, getters) => (arr, match) => {
      if (arr.length === 0) {
        return []
      }
      return arr.filter((r) => {
        let category = get(r, 'category', '')
        if (!getters.gdpr5Enabled) {
          category = get(r, 'legacyCategory', '')
        }
        let filtered =
          match !== 'fullReportList'
            ? category.substring(0, match.length) === match
            : true
        return filtered
      })
    },
    getReportsForCategory: (state, getters) => (category) => {
      // unique category not included in app search
      // requires router permission check to access
      if (category === 'adminReports') {
        return state.adminReportList
      }

      const reports = state.fullReportList
      if (category === 'fullReportList') {
        return reports
      }

      const filtered = getters.reportFilter(reports, category)
      if (filtered.length === 0) {
        return reports
      }

      return filtered
    },
    getReportBySlug: (state) => (slug) => {
      return state.fullReportList.find((report) => report.slug === slug)
    },
    getWidgetByName: (state) => (name) => {
      return state.widgetMixins[name]
    },
    getAllWidgets: (state) => () => {
      return Object.keys(state.widgetMixins)
    },
    getReportLimitBySlugAndOrgId: (state) => (slug, orgId) => {
      const limits = get(state.reportsWithLimits, orgId, null)
      return get(limits, slug, null)
    },
    getReportLimitsByOrg: (state) => (orgId) => {
      return get(state.reportsWithLimits, orgId, null)
    },
    doesReportSlugHaveLimits: (state) => (slug) => {
      const reports = state.fullReportList.filter(r => r.reportDetails.storeLimits)
      return reports.find((report) => report.slug == slug)
    },
  },
  mutations: {
    TOGGLE_IS_FETCHING_REPORTS_WITH_LIMITS: (state, flag) => {
      state.isFetchingLimits = flag
    },
    DRIVER_REG_TOGGLE: (state, flag) => {
      state.showRegDrivers = flag
    },
    CLEAR_REPORTS_WITH_LIMITS: (state) => {
      state.reportsWithLimits = {}
    },
    SET_REPORTS_WITH_LIMITS: (state, {results, orgId}) => {
      if (!state.reportsWithLimits[orgId]) {
        Vue.set(state.reportsWithLimits, orgId, {})
      }
      // probably need to do some checks before this set
      Vue.set(state.reportsWithLimits, orgId, results)
    },
  },
  actions: {
    async HYDRATE_REPORT_LIMITS ({state, commit, dispatch, rootState}, org) {
      commit('TOGGLE_IS_FETCHING_REPORTS_WITH_LIMITS', true)
      const reports = state.fullReportList.filter(r => r.reportDetails.storeLimits)
      const slugs = reports.map(r => r.slug)

      const params = {
        limitsOnly: true,
        bustCache: true,
      }
      params.since = rootState.paramsModule.since
      params.until = rootState.paramsModule.until
      await dispatch('GET_DATA_PROMISE', {
        slugs: slugs.toString(),
        params,
        orgId: org.id,
      })
      commit('TOGGLE_IS_FETCHING_REPORTS_WITH_LIMITS', false)
    },
  },
}

export default module
